import React, { useEffect } from 'react';

interface YandexMetrikaProps {
    counterId: number;
}

const YandexMetrika: React.FC<YandexMetrikaProps> = ({ counterId }) => {
    useEffect(() => {
        // Yandex.Metrika counter
        (function (m: any, e: any, t: string, r: string, i: string) {
            m[i] = m[i] || function () {
                (m[i].a = m[i].a || []).push(arguments)
            };
            m[i].l = Number(new Date());
            const k = e.createElement(t) as HTMLScriptElement;
            const a = e.getElementsByTagName(t)[0];
            k.async = true;
            k.src = r;
            a.parentNode.insertBefore(k, a);
        })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

        (window as any).ym(counterId, "init", {
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true,
            trackHash: true
        });
    }, [counterId]);

    return (
        <noscript>
            <div>
                <img
                    src={`https://mc.yandex.ru/watch/${counterId}`}
                    style={{ position: 'absolute', left: '-9999px' }}
                    alt=""
                />
            </div>
        </noscript>
    );
};

export default YandexMetrika;
